import React from 'react'
import TrashIcon from '../../elements/icons/TrashIcon'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import { transactionTimeStamp } from '../../../utils'
import { Link } from 'react-router-dom'

const AcademicSessionCard = ({session}) => {
  return (
    <div className='p-3'>

    <div className="w-full flex items-center justify-between mt-3 mb-2">
        <p className='w-full pb-2  text-xl mt-2 font-outfit font-medium'>{session.name} </p>
        {session.current && <span className={`px-2 rounded text-xs font-outfit py-1 flex items-center gap-x-1 justify-center bg-opacity-20 bg-vcm-light-purple text-vcm-purple`}>
        Current
        </span>}
        {session.closed && <span className={`px-2 rounded text-xs font-outfit py-1 flex items-center gap-x-1 justify-center bg-opacity-20 bg-gray-300 text-gray-600`}>
        Closed
        </span>}
    </div>

    <p className='w-full pb-2  text-xl font-outfit font-medium mt-2'>
        <span className='rounded px-2 py-1 text-xs bg-gray-100 text-gray-700 inline-block mr-2 mb-2'>{transactionTimeStamp(session.startDate).date}</span> - <span className='rounded px-2 py-1 text-xs bg-gray-100 text-gray-700 inline-block mr-2 mb-2'>{transactionTimeStamp(session.endDate).date}</span>
    </p>
    <div className="w-full flex items-center justify-between mt-3">
        <Link to={`/admin/administration/academic-sessions/${session._id}`}  className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>Session Details <ArrowIcon className={`w-4 h-4`} /></Link> 

        <button className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
            <TrashIcon className={`w-5 h-5`} />
        </button>
    </div>

</div>
  )
}

export default AcademicSessionCard